import React, { useRef } from 'react';
import { IProps } from './types';
import * as S from './styles';
import ComingSoonIcon from '@assets/icons/comingSoonIcon';
import UpsellIcon from '@assets/icons/upsellIcon';
import Button from '@components/Button';
import { useSelector } from 'react-redux';
import selectors from '@state/selectors';
import { IDSConfig } from '@state/dsconfig/types';

const DESCRIPTION_LIST = [
  "OEM assets at your fingertips",
  "OEM-compliant templates",
  "An intuitive editor experience with customizable templates",
  "Ability to share designs with your team",
  "Many more features to come!",
]

const ComingSoon: React.FC<IProps> = (props) => {

  const dsConfig: IDSConfig | undefined = useSelector(selectors.dsConfig.getDSConfig);

  const handleOpenUsell = () => {
    if (dsConfig) window.location.href = dsConfig.upsellUrl;
  }

  const renderContainerError = () => {
    return (
      <S.Container notCoverAll={props.upsell} >
        {!props.upsell && <S.OrangeBar />}
        <S.SubContainer  notCoverAll={props.upsell}  >
          <S.Title notCoverAll={props.upsell} >
            Design Studio {!props.upsell && "Coming Soon!"}
          </S.Title>
          {
            !props.upsell &&
            <S.IconContainer>
              <ComingSoonIcon />
            </S.IconContainer>
          }
          <S.DescriptionContainer>
            <S.Description>
              {
                props.upsell ?
                  "Your one-stop shop for all your design needs. Create amazing banners of all sizes in a matter of minutes. Design Studio is set to revolutionize the banner creation process with:"
                  :
                  "Create amazing banners of all sizes in a matter of minutes. Design Studio is set to revolutionize the banner creation process with:"
              }
            </S.Description>
            <S.DescriptionList>
              {
                DESCRIPTION_LIST.map((text, index) => {
                  return (
                    <S.DescriptionItem key={index} >
                      {text}
                    </S.DescriptionItem>
                  );
                })
              }
            </S.DescriptionList>
          </S.DescriptionContainer>
          {
            props.upsell &&
            <>
              <S.ButtonContainer>
                <Button
                  label="GET DESIGN STUDIO"
                  style={{hoverBackgroundColor: "#344a70", backgroundColor: "#19325d", width: 160, height: 36, boxSizing: 'border-box'}}
                  labelStyle={{color: "white", fontWeight: '500'}}
                  disabled={!dsConfig}
                  onClick={handleOpenUsell}
                />
              </S.ButtonContainer>
              <S.UpsellIconContainer>
                <UpsellIcon />
              </S.UpsellIconContainer>
            </>
          } 
        </S.SubContainer>
      </S.Container>
    )
  }

  return (
    <S.Root notCoverAll={props.upsell} >
      {renderContainerError()}
    </S.Root>
  );
}

export default ComingSoon;